import React from 'react';
import CredentialsContainer from './CredentialsContainer';
import { ModalProps } from 'types/Modal';
import { Credential } from 'types/Credentials';
import { NDialog } from '@innersource-nn/novoui-react';
import Spinner from 'components/loader/Spinner';

export interface CredentialsModalProps extends ModalProps {
    credentials: Credential[];
    loading: boolean;
    copyCredentials: string[];
}

export default function CredentialsModal({
    credentials,
    loading,
    copyCredentials,
    visible,
    onClose,
}: CredentialsModalProps) {
    return (
        visible &&
        onClose && (
            <NDialog
                isVisible={visible}
                headline="Credentials"
                backgroundClose
                closeDialog={onClose}
                size="large"
                showDividers={false}
            >
                {loading ? (
                    <Spinner />
                ) : (
                    <div className="text-true-blue">
                        <CredentialsContainer
                            title="Run the following commands in your terminal"
                            exportCredentials={true}
                            value={copyCredentials[0]}
                            credentials={credentials}
                        />
                        <CredentialsContainer
                            title="Copy the following commands in your AWS credentials file
                (typically located in ~/.aws/credentials)"
                            exportCredentials={false}
                            value={copyCredentials[1]}
                            credentials={credentials}
                        />
                    </div>
                )}
            </NDialog>
        )
    );
}
